import React, { useContext } from 'react';
import { AuthContext } from '../../Context/AuthProvider';
import { FaGoogle, FaGithub, FaFacebook } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GithubAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import DynamicTitle from '../../Hooks/DynamicTitle';
import { toast } from 'react-hot-toast';


const Login = () => {

    const { login, signInWithGoogle, githubSignUp } = useContext(AuthContext);

    const googleProvider = new GoogleAuthProvider();

    const location = useLocation();
    const navigate = useNavigate();

    const from = location.state?.from?.pathname || '/allServices';

    DynamicTitle('Login')

    const gitProvider = new GithubAuthProvider();

    const handleLogin = (event) => {
        event.preventDefault();
        const form = event.target;
        const email = form.email.value;
        const password = form.password.value;

        login(email, password)
            .then(userCredential => {
                const user = userCredential.user;
                console.log(user);
                toast.success('Login Successful.', {
                    position: 'top-center'
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);
                    })

                navigate(from, { replace: true })
                form.reset();
            })
            .catch((error) => {
                toast.error(`${error.message}`, {
                    position: 'top-center'
                });
                console.log(error.message, error.code);
            })
    };


    const handleGithubSignUp = () => {
        githubSignUp(gitProvider)
            .then(result => {
                const user = result.user;
                toast.success(`Login Successful. Welcome ${user.displayName}`, {
                    position: 'top-center'
                })
                navigate(from, { replace: true })
            })
            .catch((error) => {
                toast.error(`${error.message}`, {
                    position: 'top-center'
                });
                console.error("Error ", error);
            })
    };

    const handleGoogleSignIn = () => {
        signInWithGoogle(googleProvider)
            .then((result) => {
                const user = result.user;
                console.log(user);
                toast.success('Login Successful.', {
                    position: 'top-center'
                })
                navigate(from, { replace: true })
            })
            .catch((error) => {
                toast.error(`${error.message}`, {
                    position: 'top-center'
                });
                console.error(error);
            })
    }


    return (
        <div className='my-10 '>
            <h1 className='text-white text-5xl font-semibold text-center my-4'>Login</h1>
            <div className="">
                <div className="hero-content flex-col lg:flex-row">

                    <div className="card border-white flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-300 py-10">
                        <form onSubmit={handleLogin} className="card-body">
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Email</span>
                                </label>
                                <input name='email' type="email" placeholder="email" className="input input-bordered" />
                            </div>
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">Password</span>
                                </label>
                                <input name='password' type="password" placeholder="password" className="input input-bordered" />
                                <label className="label">
                                    <a href="/login" className="label-text-alt link link-hover">Forgot password?</a>
                                </label>
                            </div>
                            <div className="form-control mt-6">
                                <input className="btn bg-cyan-400 text-black hover:text-white" type="submit" value="Login" />
                            </div>
                        </form>
                        <div>
                            <p className='text-center'>Or Continue With</p>
                            <div className='flex justify-evenly align-center mx-auto my-4'>
                                <FaGoogle onClick={handleGoogleSignIn} className='cursor-pointer text-cyan-300' style={{ width: "30px", height: "30px" }}></FaGoogle>
                                <FaGithub onClick={handleGithubSignUp} className='cursor-pointer text-white' style={{ width: "30px", height: "30px" }}></FaGithub>
                                <FaFacebook className='cursor-pointer text-sky-500' style={{ width: "30px", height: "30px" }}></FaFacebook>
                            </div>
                        </div>
                        <p className='text-center'>New to Genius Car ? <Link className='text-orange-500 font-semibold' to='/signup'>Sign Up</Link></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;